export default {
      id: "ic-full-screen-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic-full-screen-usage",
      toString: function () {
        return this.url;
      }
    }